import { useGetServiceAccount } from '@/hooks/api/service-accounts/useGetServiceAccount';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useState } from 'react';
import { CreateServiceAccountModal } from './CreateServiceAccountModal';
import { DeleteServiceAccountModal } from './DeleteServiceAccountModal';
import { ServiceAccountCard } from './ServiceAccountCard';
import { ServiceAccountEmptyState } from './ServiceAccountEmptyState';
import { ServiceAccountErrorState } from './ServiceAccountErrorState';
import { ServiceAccountLoadingSkeleton } from './ServiceAccountLoadingSkeleton';
import { ServiceAccountNoPermissionState } from './ServiceAccountNoPermissionState';

export const ServiceAccountSection = () => {
  const { permissions } = useGetCurrentUser();
  const { data: serviceAccount, isLoading, error } = useGetServiceAccount();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  if (isLoading && !createModalOpen) {
    return <ServiceAccountLoadingSkeleton />;
  }

  if (error) {
    return <ServiceAccountErrorState />;
  }

  if (!permissions.canManageUsers) {
    return <ServiceAccountNoPermissionState />;
  }

  return (
    <>
      {serviceAccount ? (
        <>
          <ServiceAccountCard serviceAccount={serviceAccount} onDelete={() => setDeleteModalOpen(true)} />
          <DeleteServiceAccountModal
            isOpen={deleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            serviceAccount={serviceAccount}
            onSuccess={() => setDeleteModalOpen(false)}
          />
        </>
      ) : (
        <ServiceAccountEmptyState onCreate={() => setCreateModalOpen(true)} />
      )}
      <CreateServiceAccountModal
        key={createModalOpen ? 'open' : 'closed'}
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
      />
    </>
  );
};
